import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';

import { db } from '../lib/firebase';
import { lofLabelForUi } from '../lib/lofs';

/**
 * Firestore /lofs `lof_name` (with getLofDisplayName fallback) for shell filters and grouped UIs.
 */
export function useLofDisplayNameMap(): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>({});

  useEffect(() => {
    let cancelled = false;
    getDocs(collection(db, 'lofs'))
      .then((snap) => {
        const next: Record<string, string> = {};
        snap.docs.forEach((docSnap) => {
          const data = docSnap.data() as Record<string, unknown>;
          const fromDoc = typeof data.lof_name === 'string' && data.lof_name.trim() ? data.lof_name.trim() : '';
          next[docSnap.id] = lofLabelForUi(docSnap.id, fromDoc);
        });
        if (!cancelled) setMap(next);
      })
      .catch(() => {
        if (!cancelled) setMap({});
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return map;
}
